import { type Chat } from "instantdb/types";
import { getChats } from "instantdb/client/chat";
import { useUser } from "@/hooks/useUser";

type ChatsReturn = {
  chats: Chat[];
  isLoading: boolean;
};

export const useChats = (): ChatsReturn => {
  const { userId } = useUser();
  const { chats, isLoading } = getChats(userId);

  return {
    chats,
    isLoading,
  };
};
